import { Fragment } from "react";
import Editor from "@monaco-editor/react";
import { Button, Card, Container, Stack, TextField } from "@mui/material";
import styles from "../../Assets/css/codingform.module.css";
import DeleteIcon from "@mui/icons-material/Delete";

interface ITestCaseEditorProps {
	language: editor_languages;
	scannerInput: boolean;
	data: [
		{
			language: language_options_l;
		},
		Array<{
			scannerInput?: string;
			code?: string;
			name: string;
			output: string;
			marks?: number;
		}>
	];
	onEditorChange: (
		lang: language_options_l,
		index: number,
		value: string,
		type: "code" | "output" | "scannerInput" | "marks"
	) => unknown;
	addTestCase: (lang: language_options_l) => unknown;
	testCasePop: (lang: language_options_l) => unknown;
	type: "public" | "private";
}

export default function TestCaseEditor({
	language,
	data,
	onEditorChange,
	addTestCase,
	testCasePop,
	type,
	scannerInput,
}: ITestCaseEditorProps) {
	function getLang(language: editor_languages): language_options_l {
		switch (language) {
			case "cpp":
				return "c++";

			case "python":
				return "python3";

			default:
				return language;
		}
	}

	return (
		<Fragment>
			{data[1].map((val, index) => {
				return (
					<Card
						// className="border border-grey bg-red p-3 mb-2"
						key={index}
						sx={{
							m: 3,
							bgcolor: type === "private" ? "#81c784" : "#ff5252",
						}}
					>
						<Stack direction={"column"}>
							<Stack
								direction={"row"}
								sx={{
									py: 2,
								}}
							>
								<Container sx={{ height: "20rem" }}>
									<Container sx={{ mx: 0 }}>
										{type.toUpperCase()} {val.name}
									</Container>
									<Editor
										language={language}
										className={styles.test_case_editor}
										value={
											scannerInput
												? val.scannerInput
												: val.code
										}
										theme="vs-dark"
										height={"85%"}
										onChange={(e) => {
											if (!e) return;
											let editor_val = e;
											editor_val = editor_val.replace(
												"\r\n",
												"\n"
											);
											onEditorChange(
												getLang(language),
												index,
												editor_val,
												scannerInput
													? "scannerInput"
													: "code"
											);
										}}
									/>
								</Container>
								<Container sx={{ height: "20rem" }}>
									<Container>Output</Container>
									<Editor
										className={styles.test_case_editor}
										value={val.output}
										theme="vs-dark"
										height={"85%"}
										onChange={(e) => {
											if (!e) return;
											let editor_val = e;
											editor_val = editor_val.replace(
												"\r\n",
												"\n"
											);
											onEditorChange(
												getLang(language),
												index,
												editor_val,
												"output"
											);
										}}
									/>
								</Container>
							</Stack>
							{type === "private" && (
								<div className="my-2 mx-4">
									<label className="block mb-2 text-sm font-medium text-gray-900">
										Marks :
									</label>
									<input
										type="number"
										className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
										placeholder=""
										value={val.marks}
										onChange={(e) => {
											if (!e) return;
											onEditorChange(
												getLang(language),
												index,
												e.target.value,
												"marks"
											);
										}}
									/>
								</div>
							)}
						</Stack>
					</Card>
				);
			})}
			<Button
				className="m-2"
				variant="contained"
				onClick={() => addTestCase(getLang(language))}
			>
				Add Test Case
			</Button>
			<Button
				className="m-2"
				variant="contained"
				onClick={() => testCasePop(getLang(language))}
				color="error"
				startIcon={<DeleteIcon />}
			>
				Pop
			</Button>
		</Fragment>
	);
}
